(ns ui.editors.card.event
  (:require
   [ui.util :as uu]
   [re-frame.core :as rf]
   [potpuri.core :as p]
   [ui.state.session.model :as session-model]
   [ui.editors.card.model :as model]
   [frontend.controller.websocket.event :as ws]
   [common.util :as cu]
   [common.schema.entities.card :as card-schema]

   ;; TODO: remove this once can be done
   [frontend.state.current-session :as session]))

(rf/reg-cofx
 ::card-temp-id
 (fn [coeffects]
   (assoc coeffects :card-temp-id (uu/make-uuid))))

(rf/reg-cofx
 ::account-id
 (fn [coeffects]
   (assoc coeffects :account-id @session/account-id)))

(rf/reg-event-fx
 ::initialize
 [rf/trim-v
  (rf/inject-cofx ::card-temp-id)
  (rf/inject-cofx ::account-id)]
 (fn [{:keys [db card-temp-id account-id]} [args]]
   {:db (model/initialize-editor db
                                 (assoc args
                                        :card-temp-id card-temp-id
                                        :account-id account-id))}))

(rf/reg-event-db
 ::clear-editor-state
 (fn [db]
   (p/dissoc-in db model/root-path)))

(rf/reg-event-fx
 ::close-editor
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [apply-changes?]}]]
   (let [card (get-in db model/card-full-path)
         close-editor-callback-event (get-in db model/close-editor-callback-event-full-path)]
     {:fx [[:dispatch (conj close-editor-callback-event {:card card
                                                         :apply-changes? apply-changes?})]
           [:dispatch [::clear-editor-state]]]})))

(rf/reg-event-fx
 ::set-current-tab
 (fn [{:keys [db]} [_ new-tab]]
   {:db (assoc-in db model/current-tab-full-path new-tab)}))

(rf/reg-event-db
 ::set-card-title
 (fn [db [_ new-title]]
   (model/set-card-title db new-title)))

(rf/reg-event-db
 ::set-card-description
 (fn [db [_ new-description]]
   (model/set-card-description db new-description)))

;; Todo this will happen later from opensearch
(rf/reg-event-fx
 ::select-preview-entity
 (fn [{:keys [db]} [_ entity-id]]
   {:db (model/select-preview-entity-id db entity-id)}))


;; These create/update events are not used for now since
;; views and cards updated in a single transaction. 
;; Leave here for reference if later needed
(rf/reg-event-fx
 ::submit-failure
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (js/console.log "Submit card failure " resp)
   {:db (assoc-in db model/submitting-full-path false)}))

;; TODO: Add stale response handling below if those handlers are used.
;; Currently not used since views and cards are updated in a single transaction

(rf/reg-event-fx
 ::update-card-success
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (let [entities (-> resp :body :entities)
         card (->> entities
                   (cu/filter-by :entity/type :entity.type/card)
                   (first))
         card-id (:db/id card)
         new-db (-> db
                    (assoc-in model/submitting-full-path false)
                    (session-model/merge-entities {card-id card}))]
     {:db new-db
      :fx [[:dispatch [::clear-editor-state]]]})))

(rf/reg-event-fx
 ::update-card
 (fn [{:keys [db]}]
   (let [card (get-in db model/card-full-path)
         original-card (session-model/get-entity db (:db/id card))
         update-data (->> card
                          (card-schema/select-updatable-fields)
                          (filter (fn [[field new-value]]
                                    (not= new-value (get original-card field))))
                          (into {}))]
     {:db (assoc-in db model/submitting-full-path true)
      ::ws/send {:id :card/update
                 :body {:db/id (:db/id card)
                        :data update-data}
                 :on-success [::update-card-success]
                 :on-error [::submit-failure]}})))

(rf/reg-event-fx
 ::create-card-success
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (let [entities (-> resp :body :entities)
         card (->> entities
                   (cu/filter-by :entity/type :entity.type/card)
                   (first))
         card-id (:db/id card)
         new-db (-> db
                    (assoc-in model/submitting-full-path false)
                    (session-model/merge-entities {card-id card}))]
     {:db new-db
      :fx [[:dispatch [::clear-editor-state]]]})))

(rf/reg-event-fx
 ::create-card
 (fn [{:keys [db]}]
   (let [card (get-in db model/card-full-path)
         data (dissoc card :db/id :entity/type)]
     {:db (assoc-in db model/submitting-full-path true)
      ::ws/send {:id :card/create
                 :body data
                 :on-success [::create-card-success]
                 :on-error [::submit-failure]}})))
